import React, { useState } from "react";
import { Modal, Button } from "antd";
import logoDark from "../../assets/legalpanel-light.png";
import logoVerot from "../../assets/verot_logo.png";

const CustomModal = ({ open, onCancel }) => {
  return (
    <>
      <Modal
        title={
          <div>
            <img src={logoDark} alt="logo" style={{ height: 30 }} />
          </div>
        }
        open={open}
        onCancel={onCancel}
        footer={null}
        maskStyle={{
          backgroundColor: "rgba(0, 0, 0, 0.7)",
        }}
        bodyStyle={{
          backgroundColor: "white",
          borderRadius: 8,
          padding: 20,
        }}
      >
        <p>
          O Legal Panel é uma plataforma desenvolvida pela VEROT para a organização e gestão eficiente de escritórios de advocacia e contabilidade. Ele centraliza informações, gerencia demandas com segurança e oferece recursos como alertas
          para prazos críticos e organogramas dinâmicos. O Legal Panel visa otimizar a gestão de obrigações societárias, procurações e compliance, além de proporcionar maior segurança para escritórios e seus clientes.
        </p>

        <div style={{ marginTop: 30, textAlign: "center", fontSize: 12 }}>
          <p>Desenvolvido por</p>
          <p>© 2025 Verot Soluções em Tecnologia e Serviços Ltda.</p>
          <a href="https://verot.com.br" target="_blank" rel="noopener noreferrer">
            https://verot.com.br
          </a>
          <div style={{ marginTop: 20 }}>
            <img src={logoVerot} alt="logo" style={{ height: 20 }} />
          </div>
        </div>
      </Modal>
    </>
  );
};

export default CustomModal;
